import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from "../../bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgEventsService } from '../bpg-events.service';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  showUpcomingEventsTab: boolean = true;
  showPastEventsTab: boolean = false;
  statusList: any;
  fyList: any;
  status: any;
  fySelected: any;
  selectAllConstant = "Select All";
  userAndRoleIdDTO: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  adminId: any = localStorage.getItem('adminId');
  userBaseSiteId: any  = Number(localStorage.getItem('userSiteId'));
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  landingData: any;
  tableShow: boolean;
  chapterList: any;
  chapterIds: string;
  siteData: any;
  siteList: any;
  allSiteIds: any;
  selectedBpgsData: any;
  siteId: any = 0;
  bpgList: any;
  allBpgIds: any;
  previousButton: any;
  buttonType: any;
  eventStorageData: any;
  currentPage = 0;
  bpgValue: any;
  numberOfElements: number;
  bpgId: any = 0;
  searchKey: any;
  timeOutError: boolean;
  tableresp: boolean;
  eventsData = [];
  noDataFound: boolean;
  selectedBpgId: any = 0;
  selectedSiteId: any = 0;
  selectedStatus: any;
  selectedFy:any;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  iconKeyList: any;
  eventDetails = [];
  currentShowingElements: number = ConstantValues.pageLimit;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  method: string;
  msg1: string;
  approverComment = "";
  param: string;
  previousDate: any;
  alertDeleteSuccess: boolean;
  alertCloseSuccess: boolean;
  alertCancelSuccess: boolean;
  alertCancelAllSuccess: boolean;
  today: any = new Date();
  date: any = new Date();
  currentTime: any = `${new Date().getHours()}:${new Date().getMinutes()}`;
  currentDate: any = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  currentFiscalYear: number;
  printEventsList = [];
  showDownloadOption:boolean;
  siteNamePrint: any;
  bpgNamePrint: any;
  fiscalYearPrint : any;
  searchedData: any;
  showErrorMessage: boolean = false;
  constructor(private readonly bpgCommonService: BpgCommonService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly router: Router,
    private readonly datePipe: DatePipe,
    private readonly bpgEventsService: BpgEventsService,
    private readonly  data: DataService,
    private readonly environment: EnvironmentConfiguration) { }

  ngOnInit() {
    // by defualt user base siteId is selected
    this.siteId = this.userBaseSiteId;
    const date1 = new Date();
    const date2 = new Date(date1.setDate(date1.getDate() - 1));
    this.previousDate = this.datePipe.transform(date2, 'yyyy-MM-dd');
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
      if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }

    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }


    window.scrollTo(0, 0)
    this.spinner.show();

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin')==='true'){
      this.isbpgLeadAdmin = true;
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && this.adminId !== "4" && !this.isNaacAdmin && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }
    this.today = this.datePipe.transform(this.date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); //whatever format you need. 
    this.statusList = [{ status: this.selectAllConstant }, { status: "NEW" }, { status: "SCHEDULED" }, { status: "COMPLETED" },
    { status: "CANCELLED"},{ status: "PENDING"}];
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    // If the month is before April, the fiscal year is the previous year
    if (month < 4) {
        this.currentFiscalYear = year;
    } else {
        this.currentFiscalYear = year+1;
    }
    this.fyList = [{ fySelected: this.selectAllConstant }, { fySelected: `FY${(this.currentFiscalYear+1) % 100}` },
    {fySelected:`FY${(this.currentFiscalYear) % 100}`},{fySelected:`FY${(this.currentFiscalYear-1) % 100}`}, { fySelected: "Past FYs" }];
    const fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
    const toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);
    this.landingData = {
      "filter": {
        "chapterId": "",
        "fiscalYear": "All",
        "eventType": this.showUpcomingEventsTab ? "upcoming" : "past",
        "adminId": ""
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "event_create_date",
      "uid": ""
    }
    this.adminId = localStorage.getItem('adminId');
    this.tableShow = false;
    this.spinner.show();
    this.getChapterDropdownDetails();

    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }
  }
  

  getChapterDropdownDetails() {
    this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterList = data;
      this.chapterList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}` ; return i; })
      if (this.chapterList.length > 1) {
        this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
      }
      this.chapterIds = this.chapterList.map(chapter => chapter.chapterId).join(',');
      this.getSiteDetails();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
   });
  }

  getSiteDetails() {
    this.siteData = {
      "filter": {
        chapterId: this.chapterIds
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      
      this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });
      this.allSiteIds = this.siteList.map(site => site.siteId).join(',');


      // if admin belongs to defualt chapter then select first site from siteList
      // default siteId in prod is 1 and in qa it is 22 and check whether user is admin of basesite chapter or not
      const siteExists = this.siteList.some(site => site.siteId === this.userBaseSiteId);
      if(this.userBaseSiteId==1 ||  !siteExists){
        this.siteId = this.siteList[1].siteId;
        this.siteChange({
          siteId:this.siteId
        });
        this.selectedSiteId = this.siteId;
      }else{
        this.selectedSiteId = this.userBaseSiteId;
      }
      this.getBpgDetails();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
   });
  }

  getBpgDetails(){
    this.selectedBpgsData =
      {
        "filter": {
          "siteId": this.siteId,
          "userId": this.userAndRoleIdDTO.userId,
          "adminId": this.userAndRoleIdDTO.roleId
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": "string",
        "size": 0,
        "sortDirection": "ASC",
        "sortProperty": "string",
        "uid": "string"
      }
      this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
        this.bpgList = data;
        this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant});
        this.allBpgIds = this.bpgList.map(bpg => bpg.bpgId).join(',');
        this.afterAllDropdownLoad();
      }, err => {
        this.spinner.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
     });
  }

  afterAllDropdownLoad(){
     this.landingData.filter.siteId = this.siteId;
     this.landingData.filter.bpgId = this.allBpgIds;
     this.landingData.filter.adminId = this.adminId;
     this.landingData.filter.userId = this.loginData['userId'];
     this.spinner.show();

     this.previousButton = sessionStorage.getItem(this.buttonType);
     if ((localStorage.getItem('searchedEventList')!==null && localStorage.getItem('searchedEventList')!==undefined) || this.previousButton === 'BACK' || this.previousButton === 'CANCEL') {
       if(sessionStorage.getItem('eventDataType')!==null && sessionStorage.getItem('eventDatatype')!==undefined){
           if(sessionStorage.getItem('eventDataType')==='upcoming'){
             this.showUpcomingEventsTab = true;
             this.showPastEventsTab = false;
           }else{
             this.showPastEventsTab = true;
             this.showUpcomingEventsTab = false;
           }
           sessionStorage.removeItem('eventDataType');
       }
       this.eventStorageData = JSON.parse(localStorage.getItem('searchedEventList'));
       this.currentPage = this.eventStorageData.page + 1;
       this.landingData = this.eventStorageData;
       sessionStorage.removeItem(this.buttonType);
       localStorage.removeItem('searchedEventList');

       if (this.eventStorageData.filter.siteId !== undefined && this.eventStorageData.filter.siteId.length > 1) {
         this.siteId = 0;
         this.selectedSiteId = this.allSiteIds;
       }
       else {
         this.siteId = this.eventStorageData.filter.siteId;
         this.selectedSiteId = this.siteId;
       }
       if (this.eventStorageData.filter.bpgId !== undefined && this.eventStorageData.filter.bpgId.length > 1) {
         this.bpgId = 0;
         this.selectedBpgId = this.allBpgIds;
       }
       else {
         this.bpgId = this.eventStorageData.filter.bpgId;
         this.selectedBpgId = this.bpgId;
       }
       if(this.selectedBpgId==this.allBpgIds && this.selectedSiteId==this.allSiteIds){
        this.showErrorMessage = true;
       }
       this.searchKey = this.eventStorageData.searchTerm;
       if (this.eventStorageData.filter.status === null) {
         this.status = this.selectAllConstant;
       }
       else {
         this.status = this.eventStorageData.filter.status;
       }
       if(this.eventStorageData.filter.fiscalYear!==undefined && this.eventStorageData.filter.fiscalYear!==null){
         this.fySelected = this.eventStorageData.filter.fiscalYear;
         if(this.fySelected === 'All'){
           this.fySelected = this.selectAllConstant;
         }
         else if(this.fySelected!=='All' && this.fySelected!=="Past FYs"){
           this.fySelected = `FY${this.eventStorageData.filter.fiscalYear % 100}`;
         }
       }else{
         this.fySelected = this.selectAllConstant;
       }
       this.selectedFy = this.fySelected;
       this.getAdminEventList();
     }
     else {
      //  this.spinner.show();
        // on page load display only current fiscal years data
        this.landingData.filter.fiscalYear = this.currentFiscalYear;
        this.fySelected = `FY${this.currentFiscalYear % 100}`;
        this.selectedFy = this.fySelected;
       this.getAdminEventList();
     }
  }

  getAdminEventList() {
    this.timeOutError = false;
    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {

      this.tableShow = true;
      this.eventsData = (data !== null) ? data.content : [];
      this.numberOfElements = (data !== null) ? data.totalElements : 0;
      this.spinner.hide();
      this.searchedData = this.landingData;
      // localStorage.setItem('searchedEventList', JSON.stringify(this.landingData));
      if (this.eventsData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
        this.spinner.hide();
      }
      for (const e3 of this.eventsData) {
        e3.startTime = this.convertTimeTo24Hours(e3.startTime);
      }
      // call download events service on page load
      if(((this.selectedBpgId==this.allBpgIds && this.selectedSiteId!=this.allSiteIds)
           || (this.selectedBpgId==this.allBpgIds && this.selectedSiteId==this.allSiteIds && this.adminId!='1')
          || (this.selectedBpgId!=this.allBpgIds && this.selectedSiteId!=this.allSiteIds))
         && this.selectedFy !== 'All' && 
        this.selectedFy !== 'Past FYs' && this.selectedBpgId!=null && this.selectedBpgId!=undefined
        && this.selectedSiteId!=null && this.selectedSiteId!=undefined){
        this.getAllEventsForPrintAndDownload();
      }else{
        this.showDownloadOption = false;
      }
      
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }

  convertTimeTo24Hours(time) {

    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s([^\s]*)$/)[1];
    if (AMPM === "PM" && hours < 12) {hours = hours + 12;}
    if (AMPM === "AM" && hours === 12) {hours = hours - 12;}
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) {sHours = "0" + sHours;}
    if (minutes < 10) {sMinutes = "0" + sMinutes;}
    return `${sHours}:${sMinutes}`;

  }

  getUpcomingEvents() {
    this.showUpcomingEventsTab = true;
    this.showPastEventsTab = false;
    this.searchEvents();
  }

  getPastEvents() {
    this.showUpcomingEventsTab = false;
    this.showPastEventsTab = true;
    this.searchEvents();
  }

    /** For adding 365 days to current day
   * @class EventsApprovalComponent
   * @method addDays
   * @params Date, number
   */
    addDays(date: Date, days: number): Date {
      date.setDate(date.getDate() + days);
      return date;
    }

      /** For site change from site list 
 * @class EventsApprovalComponent
 * @method siteChange
 * @returns Promise
 */
      public siteChange(event) {
        this.bpgList = [];
        this.selectedBpgId = 0;
        this.bpgId = 0;
        this.bpgValue = null;
    
        if (event !== undefined) {
          this.selectedSiteId = event.siteId;
        } else {
          this.selectedSiteId = 0;
          this.selectedSiteId = null;
        }
    
        this.selectedBpgsData =
        {
          "filter": {
            "siteId": this.selectedSiteId,
            "userId": this.userAndRoleIdDTO.userId,
            "adminId": this.userAndRoleIdDTO.roleId
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "string",
          "searchTerm": "string",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "string",
          "uid": "string"
        }
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
          this.bpgList = data;
          this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
          for (let i = 0; i < this.bpgList.length; i++) {
            if (i === 0) {
              this.allBpgIds = this.bpgList[i].bpgId;
            } else {
              this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
            }
          }
        });
      }

        /** For bpg change from bpg list 
 * @class EventsApprovalComponent
 * @method bpgChange
 * @returns Promise
 */

  bpgChange(event) {
    if (event !== undefined) {
      this.selectedBpgId = event.bpgId;
    } else {
      this.selectedBpgId = null;
    }
  }

    /** For bpg change from bpg list 
 * @class EventsApprovalComponent
 * @method bpgChange
 * @returns Promise
 */

    changeStatus(event) {
      if (event !== undefined) {
        this.selectedStatus = event.status;
      } else {
        this.selectedStatus = null;
      }
    }

/** For bpg change from bpg list 
 * @class EventsApprovalComponent
 * @method bpgChange
 * @returns Promise
 */

   changeFYSelected(event) {
        if (event !== undefined) {
          this.selectedFy = event.fySelected;
        } else {
          this.selectedFy = null;
        }
      }

      /** For filtering data by current page 
   * @class ChapterComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {

    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) <= this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getAdminEventList();
  }

      /** For searching the table through keywords
   * @class EventsApprovalComponent
   * @method searchEvents
   */
  searchEvents() {
    this.showDownloadOption = false;
    this.currentShowingElements = ConstantValues.pageLimit;
    this.spinner.show();
    this.timeOutError = false;
    this.selectedSiteId = this.siteId;
    this.selectedBpgId = this.bpgId;
    this.selectedStatus = this.status;
    this.selectedFy = this.fySelected;
    this.landingData.page = 0;

    this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;

    this.selectedBpgId = (this.selectedBpgId) ? this.selectedBpgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';

    if (this.selectedBpgId === 0 || this.selectedBpgId == null) {
      this.selectedBpgId = this.allBpgIds;
    }
    if (this.selectedSiteId === 0 || this.selectedSiteId == null) {
      this.selectedSiteId = this.allSiteIds;
    }
    if (this.selectedStatus === this.selectAllConstant) {
      this.selectedStatus = null;
    }
    if(this.selectedFy === this.selectAllConstant){
      this.selectedFy = "All"
    }

    this.landingData.filter.siteId = this.selectedSiteId;
    this.landingData.filter.bpgId = this.selectedBpgId;
    this.landingData.filter.status = this.selectedStatus;
    this.landingData.filter.userId = this.loginData['userId'];
    this.landingData.filter.search = true;
    this.landingData.searchTerm = this.searchKey;
    // pass the fiscal year correctly
    if(this.selectedFy === 'All' || this.selectedFy === 'Past FYs'){
      this.landingData.filter.fiscalYear = this.selectedFy;
    }else{
      this.landingData.filter.fiscalYear = (this.selectedFy!=null && this.selectedFy!=undefined) ? this.getFiscalYear(this.selectedFy) : this.selectedFy;
    }
    this.landingData.filter.eventType = this.showUpcomingEventsTab ? "upcoming" : "past";

    

    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {
      this.tableShow = true;
      this.eventsData = data.content;
      // localStorage.setItem('searchedEventList', JSON.stringify(this.landingData));
      this.searchedData = this.landingData;
      this.numberOfElements = data.totalElements;
      this.currentPage = 1;
      if (this.eventsData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      for (const e1 of this.eventsData) {
        e1.startTime = this.convertTimeTo24Hours(e1.startTime);
      }
      if(this.selectedSiteId==this.allSiteIds && this.selectedBpgId==this.allBpgIds && this.adminId=='1'){
        this.showErrorMessage = true;
      }else{
        this.showErrorMessage = false;
      }
      // fetches event list for downloading
      if(((this.selectedBpgId==this.allBpgIds && this.selectedSiteId!=this.allSiteIds)
           || (this.selectedBpgId==this.allBpgIds && this.selectedSiteId==this.allSiteIds && this.adminId!='1')
          || (this.selectedBpgId!=this.allBpgIds && this.selectedSiteId==this.allSiteIds) ||
          (this.selectedBpgId!=this.allBpgIds && this.selectedSiteId!=this.allSiteIds))
         && this.selectedFy !== 'All' && 
        this.selectedFy !== 'Past FYs' && this.selectedBpgId!=null && this.selectedBpgId!=undefined
        && this.selectedSiteId!=null && this.selectedSiteId!=undefined){
        this.getAllEventsForPrintAndDownload();
      }else{
        this.showDownloadOption = false;
      }
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  viewEventDetails(eventId, type) {
    if (type === "VIEW") {
      sessionStorage.setItem(this.iconKeyList, "V");
    }
    else if (type === "APPROVE") {
      sessionStorage.setItem(this.iconKeyList, "A");
    }
    else if (type === "REJECT") {
      sessionStorage.setItem(this.iconKeyList, "R");
    }
    else if (type === "DELETE") {
      sessionStorage.setItem(this.iconKeyList, "D");
    }
    else if (type === "ATTENDENCE") {
      sessionStorage.setItem(this.iconKeyList, "T");
    }
    else {
      sessionStorage.setItem(this.iconKeyList, "C");
    }

    for (const data of this.eventsData) {
      if (data.eventId === eventId) {
        this.eventDetails = data;
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        // localStorage.setItem('searchedEventList', JSON.stringify(this.landingData));
        this.searchedData = this.landingData;
        localStorage.setItem('searchedEventList', JSON.stringify(this.searchedData));
        this.storeEventDataType();
        this.data.setApproved(type);
        localStorage.setItem('path', 'events');
        this.router.navigate(['event-view-details']);
      }
    }
  }

  editEvent(data) {
    data.edit = 'single';
    localStorage.setItem('searchedEventList', JSON.stringify(this.searchedData));
    sessionStorage.setItem('editEventData', JSON.stringify(data)); 
    this.storeEventDataType();   
  }
  editAllEvent(data) {
    data.edit = 'multi';
    localStorage.setItem('searchedEventList', JSON.stringify(this.searchedData));
    sessionStorage.setItem('editEventData', JSON.stringify(data));
    this.storeEventDataType();
  }
  // when moving to other tab needto know which tab to be selected
  storeEventDataType(){
    if(this.showUpcomingEventsTab && !this.showPastEventsTab){
      sessionStorage.setItem('eventDataType','upcoming');
    }
    if(this.showPastEventsTab && !this.showUpcomingEventsTab){
      sessionStorage.setItem('eventDataType','past');
    }
  }
    /** To close the event, this function calls when user clicks close icon
   * @class EventsApprovalComponent
   * @method completeClick
   */
    completeClick(eventId) {
      this.method = "changeEventStatus";
      this.param = 'CLOSED'
      this.msg1 = " Closing event will prevent further actions(Claim/Survey) on the event. Are you sure you want to continue? ";
      this.landingData.eventId = eventId;
    }

    /** To delete the event data, this function calls when user clicks delete icon
   * @class EventsApprovalComponent
   * @method deleteClick
   */
    deleteClick(eventId) {
      this.method = "changeEventStatus";
      this.param = "DELETED";
      this.msg1 = " Are you sure you want to delete this event ? ";
      this.landingData.eventId = eventId;
    }
  
    /** To cancel the event data, this function calls when user clicks calcel icon
     * @class EventsApprovalComponent
     * @method cancelClick
     */
    cancelClick(eventId) {
      this.method = "changeEventStatus";
      this.param = "CANCELLED";
      this.msg1 = " Are you sure you want to cancel this event ? ";
      this.landingData.eventId = eventId;
    }
  
     /** To cancel all the event data, this function calls when user clicks calcel icon
     * @class EventsApprovalComponent
     * @method cancelClick
     */
    cancelAllClick(eventId, eventGroupId) {
      this.method = "changeEventStatus";
      this.param = "CANCELLEDALL";
      this.msg1 = " Are you sure you want to cancel this entire event series ? ";
      this.landingData.eventId = eventId;
      this.landingData.eventGroupId = eventGroupId;
   
     }

       /** To view the report of the event data, this function calls when user clicks event report icon
 * @class EventsApprovalComponent
 * @method eventReportClick
 */
  eventReportClick(eventId) {
    sessionStorage.setItem(this.iconKeyList, "ER");

    for (const e of this.eventsData) {
      if (e.eventId === eventId) {
        this.eventDetails = e;
        localStorage.setItem('searchedEventList', JSON.stringify(this.searchedData));
        sessionStorage.setItem("eventDetails", JSON.stringify(this.eventDetails));
        localStorage.setItem('path', 'events');
        this.storeEventDataType(); 
        this.router.navigate(['event-report']);
      }
    }
  }

    /** For clearing edit event data
    * @class EventsApprovalComponent
    * @method clearEditEventData
    */
    public clearEditEventData() {
      localStorage.setItem('searchedEventList', JSON.stringify(this.searchedData));
      sessionStorage.setItem('editEventData', null);
      this.storeEventDataType();
    }

     /** For changing event status to closed
     * @class EventsApprovalComponent
     * @method changeEventStatus
     */
  changeEventStatus(type) {
    this.timeOutError = false;
    switch (type) {
      /*for soft-delete on database*/
      case 'DELETED': this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventStatus = 'DELETED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertDeleteSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertDeleteSuccess = false;
        }.bind(this), 2500);
        break;

      /*for changing status to close*/
      case 'CLOSED': this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventStatus = 'CLOSED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCloseSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCloseSuccess = false;
        }.bind(this), 2500);
        break;

      /*for changing status to cancelled*/
      case 'CANCELLED':
        this.landingData.eventStatus = 'CANCELLED';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCancelSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCancelSuccess = false;
        }.bind(this), 2500);
        break;

              /*for changing status to cancelled*/
      case 'CANCELLEDALL':
        this.landingData.eventStatus = 'CANCELLEDALL';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertCancelAllSuccess = true;
        setTimeout(function () {
          window.location.reload();
          this.alertCancelAllSuccess = false;
        }.bind(this), 2500);
        break;
    }
    this.bpgEventsService.updateEventStatus(this.landingData).subscribe(_data => {
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  getFiscalYear(fyString: string): number {
    const yearPart = parseInt(fyString.toString().slice(2), 10);
    const currentYear = new Date().getFullYear();
    const currentCentury = Math.floor(currentYear / 100) * 100;
    return currentCentury + yearPart;
  }

  downloadEventsList(){
    const filteredData = this.printEventsList.map(({ siteName, bpgName, eventName,
      eventCreateDate,startTime,endTime,description}) => ({ SiteName:siteName, BpgName:bpgName, EventName:eventName,
       EventDate:eventCreateDate,StartTime:startTime,EndTime:endTime,Description:description}));
    this.bpgEventsService.exportAsExcelFile(filteredData, "EventsReport"+this.selectedFy);
  }

  // print events logic
 printEvents(){
    const printContents = document.getElementById("printEvents").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    this.spinner.hide()
    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
}

getAllEventsForPrintAndDownload(){
  let fiscalYearFetch = 0;
  if(this.selectedFy!=null && this.selectedFy!=undefined){
    fiscalYearFetch = this.getFiscalYear(this.selectedFy);
  }else{
    fiscalYearFetch= null;
  }
  // newly added for printing site and bpg name in pdf
  if(this.selectedSiteId==null || this.selectedSiteId==undefined || this.selectedSiteId==0){
      this.siteNamePrint = "Select All";
    }else if(typeof(this.selectedSiteId)=='number'){
      this.siteNamePrint  = this.siteList.find(b => b.siteId === this.selectedSiteId).siteName;
    }else{
      this.siteNamePrint = "Select All";
    }
  if(this.selectedBpgId==null || this.selectedBpgId==undefined
    || this.selectedBpgId==0){
      this.bpgNamePrint = "Select All";
  }else if(typeof(this.selectedBpgId)=='number'){
    this.bpgNamePrint  = this.bpgList.find(b => b.bpgId === this.selectedBpgId).bpgName;
  }else{
    this.bpgNamePrint = "Select All";
  }
  this.fiscalYearPrint = fiscalYearFetch;
  const landingData = {
    filter: {
      chapterId:this.chapterIds,
      siteId: this.selectedSiteId = (this.selectedSiteId===null || this.selectedSiteId===undefined || this.selectedSiteId===0) ? this.allSiteIds : this.selectedSiteId,
      bpgId: this.selectedBpgId = (this.selectedBpgId===null || this.selectedBpgId===0) ? this.allBpgIds : this.selectedBpgId,
      fiscalYear : fiscalYearFetch,
      status: this.selectedStatus,
      searchTerm : this.searchKey,
      type : this.showUpcomingEventsTab ? 'upcoming' : 'past'
    }
  }
  this.bpgEventsService.getAllEventsInFiscalYear(landingData).subscribe(data => {
    if(data!=null){
      this.printEventsList = data;
      this.showDownloadOption = this.printEventsList.length>0;      
    }
  }, err => {
    this.spinner.hide();
    if (err.value.statusText === ConstantValues.unknownError) {
      this.timeOutError = true;
    }
  });
}


}
